module.exports = __webpack_public_path__ + "static/media/teatralny.bb08eca4.jpg";